import React from 'react';

import { CheckoutPrice } from '@sharedComponents/Prices';
import { IBasicTestProps } from '@styles/model';
import { ReactFCC } from '@types';

import { StyledFinalPriceRow, ContentStyled } from './styled';

export interface IFinalPriceRowProps extends IBasicTestProps {
  price: number;
  priceFontSize: string;
}

export const FinalPriceRow: ReactFCC<IFinalPriceRowProps> = ({ children, price, priceFontSize, ...rest }) => (
  <StyledFinalPriceRow {...rest}>
    <ContentStyled data-testid="final-price-row-content">{children}</ContentStyled>
    <CheckoutPrice
      data-testid="price"
      price={price}
      separator={{ separatorSize: priceFontSize, bold: true }}
      firstCurrency={{ priceSize: priceFontSize, currencySize: priceFontSize, bold: true }}
      secondCurrency={{ priceSize: priceFontSize, currencySize: priceFontSize, bold: true }}
    />
  </StyledFinalPriceRow>
);
